import { VehicleType } from "@/types/used-cars/used-cars.types";

export const getCarType = (type: string) => {
  if (type === 'used') {
    return VehicleType.Used;
  } else {
    return VehicleType.Demo;
  }
};

export const parsePresets = (presets: string[] | string | undefined) => {
  if (!presets || typeof presets === 'string') return {};

  const filtered = presets.filter(Boolean); // removes empty strings

  const [brand, model, usedCarId] = filtered;

  return {
    brand,
    model,
    usedCarId,
  };
};
